import { Component, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import _ from 'lodash';
import { SelectItem } from 'primeng/api/selectitem';



const AvailableIconsMap = {
  'fas fa-bus-alt': 'Transport',
  'fas fa-utensils': 'Food',
  'fas fa-seedling': 'Seeding',
  'fas fa-fish': 'Fishing',
  'fas fa-monument': 'History',
  'fas fa-music': 'Music',
  'fas fa-mug-hot': 'Hot Drink',
  'fas fa-mosque': 'Mosque',
  'fas fa-church': 'Church',
  'fas fa-cocktail': 'Drink',
  'fas fa-home': 'Home - Regular',
  'fas fa-igloo': 'Farm House',
  'fas fa-hotel': 'Hotel',
  'fas fa-bicycle': 'Cycling',
  'fas fa-camera': 'Photos',
  'fas fa-guitar': 'Guitar',
  'fas fa-hammer': 'Wood working',
  'fas fa-puzzle-piece': 'Games',
  'fas fa-ship': 'Boat trip',
};


@Component({
  selector: 'app-excluded-input',
  templateUrl: './excluded-input.component.html',
  styleUrls: ['./excluded-input.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ExcludedInputComponent),
    },
  ],
})
export class ExcludedInputComponent implements ControlValueAccessor {
  availableIcons = AvailableIconsMap;

  internalModel: Array<String> = [];

  tempNgModel = {
    // iconClasses: null,
    content: null,
  } as ExcludedItem;

  availableIconKeys: Array<SelectItem> = [
    {
      label: 'Select Icon',
      value: null
    },
    ... Object.keys(AvailableIconsMap).map(key => ({value: key, label: key}))
  ];
  private _touched = false;
  private _onChange = (v: any) => {};
  private _onTouched = (touched: boolean) => {};


  addItem() {
    console.log(this.internalModel , 'sss');
    if (this.tempNgModel.content) {
      this.internalModel.push(_.cloneDeep(this.tempNgModel.content));
      this.tempNgModel = {
        content: null,
      };
      this.updateNgValue();
    }
  }

  removeItem(index) {
    this.internalModel.splice(index, 1);
    this.updateNgValue();
  }

  /**
   *
   * ng value accessor functions
   */
  writeValue(newVal) {
    this.internalModel = newVal || [];
  }

  registerOnChange(onChange) {
    this._onChange = onChange;
  }

  registerOnTouched(onTouched) {
    this._onTouched = onTouched;
  }

  private updateNgValue() {
    if (!this._touched) {
      this._touched = true;
      this._onTouched(this._touched);
    }
    console.log('updating value', this.internalModel);
    this._onChange(this.internalModel);
  }
}


interface ExcludedItem {
  content: string;
}
